<template>
  <app-header class="flex justify-between pl-5 pr-7">
    <bot-selector :default-bot-id="botId"
                  :options-filter="optionsFilter"
                  @change="changeBot"
                  class="w-full"
    />
    <operator-status-switch :bot-id="botId" class="ml-2" />
  </app-header>
</template>

<script>
import AppHeader from '@/components/common/AppHeader'
import BotSelector from '@/components/common/BotSelector'
import OperatorStatusSwitch from '@/components/common/OperatorStatusSwitch'

export default {
  name: 'AppHeaderBotControl',

  components: {
    AppHeader,
    BotSelector,
    OperatorStatusSwitch
  },

  props: {
    botId: {
      type: String,
      required: true
    }
  },

  methods: {
    optionsFilter(bot) {
      if ('is_primary_variant' in bot) {
        return bot.is_primary_variant
      }

      return true
    },

    changeBot(bot) {
      this.$emit('change-bot', bot)
    }
  }
}
</script>
